import { TargetEnvironment } from './environment.interfaces';

export const environment = {
	production: false,
	baseurl: 'https://undefined.com/',
	reportsurl: 'https://undefined.com/',
	fenixReportsUrl: 'https://reports.testtools.dev.scania.com.cn/',
	reportsapiurl: 'https://undefined.com/',
	requirementsurl: 'https://undefined.com/',
	environment: TargetEnvironment.Hero,
	launchDarklyClientId: '664590c02c638010dc55095f',
	abstractionLayerStagingUrl: 'https://fabpu7q5onailaaz3eb2jq2lm4.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	abstractionLayerReleaseUrl: 'https://wjbw5doijnhwfksoq3bwv7cyn4.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	apiStagingUrl: 'https://lg7ujq3zzrcjbbmw3pe2fiaxtq.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	apiReleaseUrl: 'https://7fdf6xzq4nbkxelufy7w5k374i.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	authLayerStagingUrl: 'https://viey4lpjrre2dpkldbqhoo6pby.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	authLayerReleaseUrl: 'https://a3ws6pttlzc7flsoyuudnmzurm.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
	externalAbstractionLayerStagingUri: null,
	externalAbstractionLayerReleaseUri: null,
	logConfig: {
		application: 'resultsweb',
		env: 'dev-hero',
		graphqlUrl: 'https://4wu25lkmsreufnzqpwkuku77my.appsync-api.cn-northwest-1.amazonaws.com.cn/graphql',
		logLevel: 2,
		console: true,
		debounceTime: 5000,
	},
	cognitoConfig: undefined,
	oneTimeTokenName: 'fenixOneTimeToken',
	redirectUrl: 'https://start.testtools.dev.scania.com.cn/login',
	homeUrl: 'https://start.testtools.dev.scania.com.cn',
	wikiUrl: 'https://confluence.collaborationlayer-traton.com/spaces/TW/pages/88968932/6+Fenix+Results',
	supportUrl:
		'https://teams.microsoft.com/l/team/19%3Af0563924f10948e29b24c3580bfa34a6%40thread.tacv2/conversations?groupId=34884b53-40a8-4388-b61a-a801abce4000&tenantId=3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
};

export const Config = {
	colaConfig: {
		disabled: false,
		redirectUrl: 'https://start.testtools.dev.scania.com.cn/login',
	},
};
